import React from "react";
import Skeleton from "../../skeleton/Skeleton";
import EmptyChart from "../../../assets/illustrations/empty-chart.png";

export const BaseChart = ({ Chart, data, options, title, isDataLoaded = false }) => {
    return (
        <div className="chart-container">
            {title ? <div className="chart-title">
                {title}
            </div> : null}
            {!isDataLoaded ? <div className="chart-loader-container"><Skeleton type="block" /></div> :
                !data?.datasets?.length ? <div className="empty-chart-state">
                    <img src={EmptyChart} />
                    <div>
                        There's not enough data to display this chart
                    </div>
            </div> : <Chart options={options} data={data} />}
        </div>
    );
}